export default {
	setSeo(seo) {
		if(typeof(window) === 'undefined') {
			this.$set(this.$store.state, 'seo', seo);
			return;
		}
		document.head.querySelector('title').innerHTML = seo.title;
		document.head.querySelector('meta[name="description"]').content = seo.description;
		document.head.querySelector('meta[name="keywords"]').content = seo.keywords;
		document.head.querySelector('meta[property="og:url"]').content = window.location.href;
		document.head.querySelector('meta[property="og:title"]').content = seo.title;
		document.head.querySelector('meta[property="og:description"]').content = seo.description;
		document.head.querySelector('meta[property="og:image"]').content = seo.image;
		document.head.querySelector('meta[name="twitter:title"]').content = seo.title;
		document.head.querySelector('meta[name="twitter:description"]').content = seo.description;
		document.head.querySelector('meta[name="twitter:image"]').content = seo.image;
	}
};